import CarnetIcon from '../icons/id-card.svg'
import CarnetIcon2 from '../icons/Reves.svg'
import SelfieIcon from '../icons/selfie.svg'

const documentAttach = [
  {
    title: 'Foto Selfie',
    headers: ['- Tu cara debe estar visible', '- Debes sostener su cédula'],
    type: 'selfie',
    icon: SelfieIcon,
    cameraOverlay: '/selfieOverlay.png',
  },
  {
    title: 'Foto Carnet/Pasaporte',
    headers: ['- Adjuntar parte delantera', '- Tu cédula debe estar vigente'],
    type: 'identityDocumentFront',
    icon: CarnetIcon,
    cameraOverlay: '/carnetOverlay.png',
  },
  {
    title: 'Foto Carnet/Pasaporte',
    headers: ['- Adjuntar parte trasera', '- Tu cédula debe estar vigente'],
    type: 'identityDocumentBack',
    icon: CarnetIcon2,
    cameraOverlay: '/carnetOverlay.png',
  },
]

export { documentAttach }
